export const theme = {
  fontWeight: {
    thin: `font-weight: 100;`,
    light: `font-weight: 300;`,
    regular: `font-weight: 400;`,
    bold: `font-weight: 700;`,
    black: `font-weight: 900;`,
  },
  colors: {
    blue100: '#EFF5FC',
    blue200: '#DEF5FB', 
    blue300: '#9CDFF2', 
    blue400: '#23B9E2',

    gray100: '#F6F6F6',
    gray200: '#E5E5E5',
    gray300: '#D8D8D8',
    gray400: '#C4C4C4',
    gray450: '#9FB2BC',
    gray500: '#4A5B64',
    gray600: '#656E73',
    gray700: '#464646',
    gray800: '#444444',

    green100: '#A9EED8',
    green200: '#1AD598',

    red100: '#FDF5F5',
    red200: '#F5D0D3',
    red300: '#F67D88',

    white: '#FFFFFF',

    yellow400: '#F9B959',

    zinc400: '#9FB2BC',
  },
  media: {
    bp1: '(max-width: 2560px)',
    bp2: '(max-width: 1680px)',
    bp3: '(max-width: 1360px)',
    bp4: '(max-width: 1024px)',
    bp5: '(max-width: 768px)',
    bp6: '(max-width: 480px)',
  },
}